var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#89D5D1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.0949 41.8542C45.6931 42.4584 46.6625 42.4584 47.2607 41.8542C47.8795 41.25 47.8795 40.2709 47.2814 39.6667L41.3614 33.6667C41.217 33.5209 41.052 33.4167 40.8663 33.3334C40.6807 33.25 40.4951 33.2084 40.2888 33.2084C40.0825 33.2084 39.8762 33.25 39.6906 33.3334C39.505 33.4167 39.3399 33.5209 39.1955 33.6667L33.2962 39.6667C32.698 40.2709 32.698 41.25 33.2962 41.8542C33.8944 42.4584 34.8639 42.4584 35.462 41.8542L38.7418 38.5209V48.5834C38.7418 49.4375 39.4224 50.125 40.2888 50.125C41.1345 50.125 41.8152 49.4375 41.8152 48.5834V38.5209L45.0949 41.8542ZM56.3087 33.8034C56.7935 33.7978 57.3215 33.7917 57.8012 33.7917C58.3168 33.7917 58.75 34.2084 58.75 34.7292V51.4792C58.75 56.6459 54.5833 60.8334 49.4678 60.8334H33.0693C27.6856 60.8334 23.3333 56.4375 23.3333 51.0209V28.5625C23.3333 23.3959 27.4794 19.1667 32.6361 19.1667H43.651C44.1667 19.1667 44.5998 19.6042 44.5998 20.125V26.8334C44.5998 30.6459 47.6939 33.7709 51.4893 33.7917C52.3569 33.7917 53.1271 33.7982 53.8037 33.804C54.3336 33.8085 54.806 33.8125 55.2228 33.8125C55.5164 33.8125 55.897 33.8081 56.3087 33.8034ZM56.8847 30.7625C55.1892 30.7688 53.1925 30.7625 51.7547 30.7479C49.4734 30.7479 47.5943 28.85 47.5943 26.5459V21.0542C47.5943 20.1563 48.671 19.7104 49.2878 20.3584C50.8754 22.0241 53.3055 24.5766 55.3601 26.7347C56.1937 27.6103 56.9656 28.421 57.5943 29.0813C58.1945 29.7125 57.7531 30.7604 56.8847 30.7625Z",
    fill: "#16625E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.c5df96919e8f3f06580926f8e3763df5.svg";
export { ForwardRef as ReactComponent };